import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/b2b-travel-portal-head.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2BTP = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2B Travel Portal
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2B Travel Portal
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					B2B Booking System
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2b-travel-portal.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2B Travel Portal means Business to Business Travel Portal in
								which Principal Travel Agencies directly connected to a travel
								agent. On B2B Travel Portals only registered agents can use the
								services. Arya Aviation B2B Travel Portal provides complete
								control of creating agents and their logins, wallet action like
								top-up and deduction of credit limit / balance, activating or
								deactivating agents, monitoring bookings / sales, modifying
								mark-ups / discounts. All like B2C this portal also has many
								services like Flight Booking, Hotel Booking, Bus/Car Booking. As
								Arya Aviation team have 7+ years great experience in travel
								technology so we develop user friendly B2B portal UI and strong
								mid office loaded with all updated features. musafir provides
								technically strong and reliable B2B Travel Portal Solution so
								you and your sub Agent both will grow your Travel Business. In
								B2B Portal, you can create sub-agents for your Agency and
								increase your sales network. Agents can log in and can use
								services. We take its pride with B2B Travel Portal Designs and
								Development with 25+ GDS or Major LCCs API Integration. We
								ensure to provide you with significant high-quality web designs
								integrated with booking engines of travel services and Travel
								Company CRM. Our strong B2B Booking Systems have GDS API
								Integration or third party API integration that facilitates 24/7
								real time travel solutions for flight booking, coach booking,
								hotel booking and bus/car booking. Features like a payment
								gateways can be added to wallet top up . Moreover, there are
								support or helpdesk window for issue resolving.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default B2BTP;
